export * from './ogc-filter-form.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/ogc-filter-form/index.ts